import OrderIcon from '@mui/icons-material/AttachMoney';
import ExamList from './ExamList';
export default {
    list: ExamList,
    icon: OrderIcon,
    recordRepresentation: 'reference',
};
